import React from 'react';
import { MicroFrontend } from '../core';
import { constants } from './constants';
import {
  FrInvestmentMicroFrontendProps,
  FrInvestmentMicroFrontendParams,
} from './types';

export const FrInvestmentMicroFrontend = (
  props: FrInvestmentMicroFrontendProps,
) => {
  return (
    <MicroFrontend<FrInvestmentMicroFrontendParams>
      entryPointUrl={props.entryPointUrl}
      history={props.history}
      name={constants.MFE_NAME}
      exposedPath={constants.MFE_EXPOSED_PATH}
      userInfo={props.userInfo}
      basePath={props.basePath}
      params={props.params}
    />
  );
};
